var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolPaymentReminders01 = function SvgSolPaymentReminders01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_payment_reminders-01_svg2__a",
    x1: 25.71,
    x2: 184.39,
    y1: 174.13,
    y2: 21.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_payment_reminders-01_svg2__a",
    id: "sol_payment_reminders-01_svg2__b",
    x1: 27.94,
    x2: 186.62,
    y1: 176.44,
    y2: 23.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_payment_reminders-01_svg2__a",
    id: "sol_payment_reminders-01_svg2__c",
    x1: -10.97,
    x2: 147.71,
    y1: 136.1,
    y2: -16.94
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_payment_reminders-01_svg2__a",
    id: "sol_payment_reminders-01_svg2__d",
    x1: 2.01,
    x2: 160.69,
    y1: 149.56,
    y2: -3.48
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_payment_reminders-01_svg2__a",
    id: "sol_payment_reminders-01_svg2__e",
    x1: 14.99,
    x2: 173.67,
    y1: 163.02,
    y2: 9.98
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_payment_reminders-01_svg2__a",
    id: "sol_payment_reminders-01_svg2__f",
    x1: 27.97,
    x2: 186.65,
    y1: 176.47,
    y2: 23.44
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_payment_reminders-01_svg2__a",
    id: "sol_payment_reminders-01_svg2__g",
    x1: 40.8,
    x2: 199.48,
    y1: 189.78,
    y2: 36.74
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_payment_reminders-01_svg2__a",
    id: "sol_payment_reminders-01_svg2__h",
    x1: 1.08,
    x2: 159.76,
    y1: 148.59,
    y2: -4.44
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_payment_reminders-01_svg2__a",
    id: "sol_payment_reminders-01_svg2__i",
    x1: 14.06,
    x2: 172.74,
    y1: 162.05,
    y2: 9.02
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_payment_reminders-01_svg2__a",
    id: "sol_payment_reminders-01_svg2__j",
    x1: 27.04,
    x2: 185.72,
    y1: 175.51,
    y2: 22.47
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_payment_reminders-01_svg2__a",
    id: "sol_payment_reminders-01_svg2__k",
    x1: 40.02,
    x2: 198.7,
    y1: 188.97,
    y2: 35.93
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_payment_reminders-01_svg2__a",
    id: "sol_payment_reminders-01_svg2__l",
    x1: 52.85,
    x2: 211.53,
    y1: 202.27,
    y2: 49.23
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_payment_reminders-01_svg2__a",
    id: "sol_payment_reminders-01_svg2__m",
    x1: 26.27,
    x2: 184.95,
    y1: 174.71,
    y2: 21.67
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_payment_reminders-01_svg2__a",
    id: "sol_payment_reminders-01_svg2__n",
    x1: 39.25,
    x2: 197.93,
    y1: 188.17,
    y2: 35.13
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_payment_reminders-01_svg2__a",
    id: "sol_payment_reminders-01_svg2__o",
    x1: 52.23,
    x2: 210.91,
    y1: 201.62,
    y2: 48.59
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_payment_reminders-01_svg2__a",
    id: "sol_payment_reminders-01_svg2__p",
    x1: 65.05,
    x2: 223.74,
    y1: 214.93,
    y2: 61.89
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_payment_reminders-01_svg2__a",
    id: "sol_payment_reminders-01_svg2__q",
    x1: 51.45,
    x2: 210.13,
    y1: 200.82,
    y2: 47.79
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_payment_reminders-01_svg2__a",
    id: "sol_payment_reminders-01_svg2__r",
    x1: 64.43,
    x2: 223.11,
    y1: 214.28,
    y2: 61.25
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_payment_reminders-01_svg2__a",
    id: "sol_payment_reminders-01_svg2__s",
    x1: 77.26,
    x2: 235.94,
    y1: 227.58,
    y2: 74.55
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M65.55 132.01c-2.07 0-4 .13-5.86.31v-3.66c0-8.49-15.01-12.93-29.85-12.93S0 120.16 0 128.66v48.23c0 8.49 15.01 12.93 29.85 12.93 5.96 0 12.07-.77 17.2-2.26 5.1 1.66 11.65 2.57 18.51 2.57 14.83 0 29.84-4.44 29.84-12.94v-32.26c0-8.49-15.01-12.93-29.84-12.93Zm24.02 28.9c0 2.41-8.48 7.11-24.02 7.11-2 0-4-.17-5.86-.38v-10.08c.26.02.53.05.8.07.16.01.31.03.47.04q.93.075 1.89.12l.63.03c.61.02 1.23.04 1.87.04h.2c8.9 0 18.21-1.55 24.02-4.84v7.88Zm-61.51-19.34h.16c.54.01 1.08.02 1.63.02.5 0 1.01 0 1.51-.02.24 0 .49-.01.73-.02.24 0 .47-.01.71-.02.36-.01.73-.03 1.09-.05.07 0 .13 0 .2-.01 7.51-.42 14.89-1.95 19.77-4.72v8.19c0 2.41-8.48 7.11-24.02 7.11S5.82 147 5.82 144.94v-8.3c5.35 3.05 13.72 4.72 22.24 4.92ZM5.83 152.84c5.79 3.31 15.08 5.04 24.02 5.04s18.21-1.55 24.02-4.84v7.88c0 2.41-8.48 7.11-24.02 7.11s-24.02-4.7-24.02-7.11zm59.72-15.01c15.54 0 24.02 4.7 24.02 7.11 0 1.97-8.19 6.77-24.02 7.11-.93 0-1.83-.04-2.71-.09-.26-.01-.51-.03-.77-.05-.68-.05-1.36-.1-2.04-.17l-.34-.03v-13.55c1.91-.19 3.81-.33 5.86-.33m-35.7-16.28c14.9 0 24.02 4.6 24.02 7.11 0 .16-.04.32-.11.49 0 .02-.03.05-.04.08-1.19 2.57-10.03 6.55-23.87 6.55q-1.44 0-2.79-.06c-.22 0-.43-.03-.65-.04-.69-.03-1.37-.07-2.03-.12-.11 0-.21-.02-.32-.03-11.88-1.03-18.23-5.07-18.23-6.86 0-2.51 9.12-7.11 24.02-7.11ZM5.83 176.89v-7.88c5.81 3.29 15.12 4.84 24.02 4.84s18.21-1.55 24.02-4.84v7.88c0 2.06-8.42 7.11-24.02 7.11s-24.02-4.7-24.02-7.11m59.72 7.42c-3.26 0-6.42-.22-9.35-.64 2.32-1.86 3.49-4.02 3.49-6.47v-3.7c1.91.2 3.88.35 5.86.35 8.9 0 18.21-1.55 24.02-4.84v8.19c0 2.41-8.48 7.11-24.02 7.11",
    style: {
      fill: "url(#sol_payment_reminders-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.11 24.91h-7.96v-6.8c0-4.46-3.77-8.24-8.24-8.24h-5.01c-4.47 0-8.24 3.77-8.24 8.24v6.8H140.8v-6.8c0-4.46-3.77-8.24-8.24-8.24h-5.01c-4.46 0-8.24 3.77-8.24 8.24v6.8H99.45v-6.8c0-4.46-3.77-8.24-8.24-8.24H86.2c-4.47 0-8.24 3.77-8.24 8.24v6.8H58.1v-6.8c0-4.46-3.77-8.24-8.24-8.24h-5.01c-4.47 0-8.24 3.77-8.24 8.24v6.8h-7.73c-5.58 0-10.12 4.68-10.12 10.43v74.85c0 1.61 1.3 2.91 2.91 2.91s2.91-1.3 2.91-2.91V52.97h169.56v108.58c0 1.22-.88 2.1-2.1 2.1h-90.51c-1.61 0-2.91 1.3-2.91 2.91s1.3 2.91 2.91 2.91h90.51c4.44 0 7.92-3.48 7.92-7.92V35.33c0-5.51-4.25-9.99-9.89-10.42Zm-23.62-6.81c0-1.22 1.19-2.41 2.41-2.41h5.01c1.22 0 2.41 1.19 2.41 2.41v12.21c0 1.17-.85 2.41-2.41 2.41h-5.01c-1.22 0-2.41-1.19-2.41-2.41zm-41.34 0c0-1.22 1.19-2.41 2.41-2.41h5.01c1.22 0 2.41 1.19 2.41 2.41v12.21c0 1.22-1.19 2.41-2.41 2.41h-5.01c-1.22 0-2.41-1.19-2.41-2.41zm-41.34 0c0-1.22 1.19-2.41 2.41-2.41h5.01c1.22 0 2.41 1.19 2.41 2.41v12.21c0 1.22-1.19 2.41-2.41 2.41h-5.01c-1.22 0-2.41-1.19-2.41-2.41zm-41.34 0c0-1.22 1.19-2.41 2.41-2.41h5.01c1.22 0 2.41 1.19 2.41 2.41v12.21c0 1.22-1.19 2.41-2.41 2.41h-5.01c-1.22 0-2.41-1.19-2.41-2.41zM24.62 35.33c0-2.54 1.92-4.6 4.29-4.6h7.42v.53c0 4.09 3.2 7.3 7.3 7.3h7.52c3.96 0 7.3-3.34 7.3-7.3v-.53h19.54v.53c0 3.96 3.34 7.3 7.3 7.3h7.2c4.09 0 7.3-3.2 7.3-7.3v-.53h19.54v.53c0 3.96 3.34 7.3 7.3 7.3h7.2c4.09 0 7.3-3.2 7.3-7.3v-.53h19.54v.53c0 4.09 3.2 7.3 7.3 7.3h7.2c3.96 0 7.3-3.34 7.3-7.3v-.53h7.3c2.56.24 4.41 2.16 4.41 4.6v11.81H24.62z",
    style: {
      fill: "url(#sol_payment_reminders-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7 82.71h15.66c1.61 0 2.91-1.3 2.91-2.91V64.14c0-1.61-1.3-2.91-2.91-2.91H47.7c-1.61 0-2.91 1.3-2.91 2.91V79.8c0 1.61 1.3 2.91 2.91 2.91m2.91-15.66h9.83v9.83h-9.83z",
    style: {
      fill: "url(#sol_payment_reminders-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.63 82.71h15.66c1.61 0 2.91-1.3 2.91-2.91V64.14c0-1.61-1.3-2.91-2.91-2.91H74.63c-1.61 0-2.91 1.3-2.91 2.91V79.8c0 1.61 1.3 2.91 2.91 2.91m2.91-15.66h9.83v9.83h-9.83z",
    style: {
      fill: "url(#sol_payment_reminders-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.57 82.71h15.66c1.61 0 2.91-1.3 2.91-2.91V64.14c0-1.61-1.3-2.91-2.91-2.91h-15.66c-1.61 0-2.91 1.3-2.91 2.91V79.8c0 1.61 1.3 2.91 2.91 2.91m2.91-15.66h9.83v9.83h-9.83z",
    style: {
      fill: "url(#sol_payment_reminders-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.5 82.71h15.66c1.61 0 2.91-1.3 2.91-2.91V64.14c0-1.61-1.3-2.91-2.91-2.91H128.5c-1.61 0-2.91 1.3-2.91 2.91V79.8c0 1.61 1.3 2.91 2.91 2.91m2.91-15.66h9.83v9.83h-9.83z",
    style: {
      fill: "url(#sol_payment_reminders-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.12 82.71h15.66c1.61 0 2.91-1.3 2.91-2.91V64.14c0-1.61-1.3-2.91-2.91-2.91h-15.66c-1.61 0-2.91 1.3-2.91 2.91V79.8c0 1.61 1.3 2.91 2.91 2.91m2.91-15.66h9.83v9.83h-9.83z",
    style: {
      fill: "url(#sol_payment_reminders-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.79 103.91c0 1.61 1.3 2.91 2.91 2.91h15.66c1.61 0 2.91-1.3 2.91-2.91V88.25c0-1.61-1.3-2.91-2.91-2.91H47.7c-1.61 0-2.91 1.3-2.91 2.91zm5.82-12.74h9.83V101h-9.83z",
    style: {
      fill: "url(#sol_payment_reminders-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.72 103.91c0 1.61 1.3 2.91 2.91 2.91h15.66c1.61 0 2.91-1.3 2.91-2.91V88.25c0-1.61-1.3-2.91-2.91-2.91H74.63c-1.61 0-2.91 1.3-2.91 2.91zm5.82-12.74h9.83V101h-9.83z",
    style: {
      fill: "url(#sol_payment_reminders-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.65 103.91c0 1.61 1.3 2.91 2.91 2.91h15.66c1.61 0 2.91-1.3 2.91-2.91V88.25c0-1.61-1.3-2.91-2.91-2.91h-15.66c-1.61 0-2.91 1.3-2.91 2.91zm5.83-12.74h9.83V101h-9.83z",
    style: {
      fill: "url(#sol_payment_reminders-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.59 103.91c0 1.61 1.3 2.91 2.91 2.91h15.66c1.61 0 2.91-1.3 2.91-2.91V88.25c0-1.61-1.3-2.91-2.91-2.91H128.5c-1.61 0-2.91 1.3-2.91 2.91zm5.82-12.74h9.83V101h-9.83z",
    style: {
      fill: "url(#sol_payment_reminders-01_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.21 103.91c0 1.61 1.3 2.91 2.91 2.91h15.66c1.61 0 2.91-1.3 2.91-2.91V88.25c0-1.61-1.3-2.91-2.91-2.91h-15.66c-1.61 0-2.91 1.3-2.91 2.91zm5.82-12.74h9.83V101h-9.83z",
    style: {
      fill: "url(#sol_payment_reminders-01_svg2__l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.72 128.34c0 1.61 1.3 2.91 2.91 2.91h15.66c1.61 0 2.91-1.3 2.91-2.91v-15.66c0-1.61-1.3-2.91-2.91-2.91H74.63c-1.61 0-2.91 1.3-2.91 2.91zm5.82-12.74h9.83v9.83h-9.83z",
    style: {
      fill: "url(#sol_payment_reminders-01_svg2__m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.65 128.34c0 1.61 1.3 2.91 2.91 2.91h15.66c1.61 0 2.91-1.3 2.91-2.91v-15.66c0-1.61-1.3-2.91-2.91-2.91h-15.66c-1.61 0-2.91 1.3-2.91 2.91zm5.83-12.74h9.83v9.83h-9.83z",
    style: {
      fill: "url(#sol_payment_reminders-01_svg2__n)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.59 128.34c0 1.61 1.3 2.91 2.91 2.91h15.66c1.61 0 2.91-1.3 2.91-2.91v-15.66c0-1.61-1.3-2.91-2.91-2.91H128.5c-1.61 0-2.91 1.3-2.91 2.91zm5.82-12.74h9.83v9.83h-9.83z",
    style: {
      fill: "url(#sol_payment_reminders-01_svg2__o)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.21 128.34c0 1.61 1.3 2.91 2.91 2.91h15.66c1.61 0 2.91-1.3 2.91-2.91v-15.66c0-1.61-1.3-2.91-2.91-2.91h-15.66c-1.61 0-2.91 1.3-2.91 2.91zm5.82-12.74h9.83v9.83h-9.83z",
    style: {
      fill: "url(#sol_payment_reminders-01_svg2__p)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.65 152.77c0 1.61 1.3 2.91 2.91 2.91h15.66c1.61 0 2.91-1.3 2.91-2.91v-15.66c0-1.61-1.3-2.91-2.91-2.91h-15.66c-1.61 0-2.91 1.3-2.91 2.91zm5.83-12.75h9.83v9.83h-9.83z",
    style: {
      fill: "url(#sol_payment_reminders-01_svg2__q)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.59 152.77c0 1.61 1.3 2.91 2.91 2.91h15.66c1.61 0 2.91-1.3 2.91-2.91v-15.66c0-1.61-1.3-2.91-2.91-2.91H128.5c-1.61 0-2.91 1.3-2.91 2.91zm5.82-12.75h9.83v9.83h-9.83z",
    style: {
      fill: "url(#sol_payment_reminders-01_svg2__r)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.21 152.77c0 1.61 1.3 2.91 2.91 2.91h15.66c1.61 0 2.91-1.3 2.91-2.91v-15.66c0-1.61-1.3-2.91-2.91-2.91h-15.66c-1.61 0-2.91 1.3-2.91 2.91zm5.82-12.75h9.83v9.83h-9.83z",
    style: {
      fill: "url(#sol_payment_reminders-01_svg2__s)"
    }
  }));
};
export default SvgSolPaymentReminders01;